export class SocureApplicantStatus {
  applicantId: number;
  status : string = "";
  qrCode: string;
  eventId: string;

  constructor(applicantId : number, status : string, qrCode : string, eventId : string) {
    this.applicantId = applicantId;
    this.status = status;
    this.qrCode = qrCode;
    this.eventId = eventId;
  }
}
